import React from 'react';

export function DomainViewBasicDetails({ domain }) {
  return (
    <table className="project-summary__info">
      <tbody>
        {/*<tr>
                <th>Name</th>
                <td>{domain?.name}</td>
            </tr>*/}
        <tr>
          <th>Description</th>
          <td>{domain?.description}</td>
        </tr>
      </tbody>
    </table>
  );
}
